<template>
  <div
    class="insurance-description-auto wc bg-white"
    :class="{ business: conf }"
  >
    <div class="insurance-description-auto__wrapper container flex j_sb">
      <div class="insurance-description-auto__left-col flex column">
        <h1 class="f-38 bold uppercase" v-if="windowWidth >= 768">
          {{ content.title }}
        </h1>
        <div
          class="insurance-description-auto__row flex column wc"
       
        >
          <h3 class="f-18" :class="{ bold: !conf, medium: conf }">
            {{ _.get(tab, 'title') }}
          </h3>
          <div
            v-html="_.get(tab, 'content')"
            class="insurance-description-auto__editor"
          ></div>
        </div>
        <div class="insurance-decription__row flex wc-lg wrap">
          <div
            class="insurance-description__btn button bg-light-purple pointer"
            @click="onCallClick"
          >
            <svg
              id="Group_5_Copy_3"
              data-name="Group 5 Copy 3"
              xmlns="http://www.w3.org/2000/svg"
              width="11.352"
              height="11.351"
              viewBox="0 0 11.352 11.351"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                fill="#fff"
              />
            </svg>
            <span class="f-14 bold f-white uppercase">{{
              content.button_name
            }}</span>
          </div>
        
        </div>
      </div>
      <h1 class="f-38 bold uppercase" v-if="windowWidth <= 767">
        {{ content.title }}
      </h1>

      <div class="insurance-description-auto__right-col br-12">
        <img
          :src="content.image[0].url"
          :alt="_.get(content, 'image[0].title.title')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
export default {
  props: ["contentData"],
  mixins: [resize_handler],
  data() {
    return {
    };
  },
  mounted() {
  },
  computed: {
    content() {
      return _.get(this.contentData, "data.list[0]");
    },
    content_types(){
      return _.get(this.$store, "state.main.indx.terms.asset_type");
    },
    popuptitle(){
      return this.content_types.find(item => item.id === this.content.asset_type[0])
    },
    tab(){
      return _.get(this.content, 'content.tabs[0]');
    },
    modal_data(){
      this.$store.state.main.set_price_title = _.get(this.content, "title");
      let arr =  _.get(this.content, 'content.tabs[1]'), _arr =  _.get(this.content, 'content.tabs[2]'), arr_final = [], asset_types;
      asset_types = this.$store.state.main.indx.terms.asset_type.filter(ty => _.get(this.content, 'asset_type').includes(ty.id))
      arr_final.push(arr, _arr);
      arr_final.image =  _.get(this.content, 'image[1].url');
      arr_final.selector_title = _.get(this.content, 'asset_selector_title')
      arr_final.asset_types =  asset_types;
      arr_final.pic_layout =  _.get(this.content, 'modal_pic_layout') === 'yes' ? true : false;
      return arr_final;
    },
    conf() {
      return _.get(this.contentData, "conf.conf[0]");
    }
  },
  watch: {
    contentData: {
      immediate: true,
      handler(ns){
        this.$store.commit("main/setState", {key: 'set_price_data', val: this.modal_data})
        this.$store.state.main.mails_taxonomy = _.get(this.contentData, 'data.list.0.mails') || false;
      }
    }
  },
  methods:{
    onCallClick(){
      this.$store.commit('main/setState', { key: 'price_modal', val: true }) 
      this.$store.state.main.mails_taxonomy = _.get(this.contentData, 'data.list.0.mails') || false;
      this.$store.state.main.set_price_title = this.popuptitle.title;
    }
  }
};
</script>

<style lang="sass" scoped>
.insurance-description-auto.business
    .insurance-description-auto__editor
        &::v-deep
            p, span, h1, h2, h3, h4, h5, h6, ul, li, strong, em
                color: white
    .insurance-description__btn
        &:nth-child(2)
            border-color: white
            span
                color: white
            svg path 
                fill: white
            @media (min-width: 1024px)
                &:hover 
                    span
                        color: white
                    border-color: #613DD1
                    background-color: #613DD1
</style>
